import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { RoutesKeys } from 'src/app/utils/routes';

@Injectable({
  providedIn: 'root',
})
/**
 * This prevents okta callback component doing nothing when missing code
 */
export class OktaCallbackGuard implements CanActivate {
  /**
   * @constructor
   */
  constructor(private readonly router: Router) {}

  /**
   * @param {ActivatedRouteSnapshot} _ not used
   * @param {RouterStateSnapshot} routerState for url
   * @return {boolean}
   */
  canActivate(
    _: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot
  ): boolean {
    const isValidRedirectURL = this.isValidRedirectURL(routerState.url);
    if (!isValidRedirectURL) {
      this.router.navigate([RoutesKeys.HOME]);
    }
    return isValidRedirectURL;
  }

  /**
   * Checks if a given URL is a valid redirect url
   * @param {string} url url to check
   * @return {boolean}
   */
  private isValidRedirectURL(url: string): boolean {
    const callbackWithCode = url.split('/login/')[1];
    if (!callbackWithCode) {
      return false;
    }
    const hasCodeParam = callbackWithCode.match(/callback\?code=.+/);
    return Boolean(hasCodeParam && hasCodeParam?.length > 0);
  }
}
